export enum VerifiedStyleOptions {
  Badge = 'BADGE',
  Text = 'TEXT',
}
